import GeneratedPropertyServiceApi from "./generated/GeneratedPropertyServiceApi"

class PropertyServiceApi extends GeneratedPropertyServiceApi {

}

export const propertyServiceApi = new PropertyServiceApi()
